import React from 'react';
import { Progress, Popover, Flex } from 'antd';
import { useAppSelector } from 'utilities/hooks';
import StorageProgressBar from './index';
import { DatabaseOutlined } from '@ant-design/icons';

const STORAGE_LIMIT_THRESHOLD = 80;

export const SmallStorageProgressBar: React.FC = () => {
    const storageSize = useAppSelector<{ size: number; limit: number } | null>((state) => state.documents.storageSize);

    if (!storageSize) {
        return null;
    }

    const { size, limit } = storageSize;
    const percentage = limit > 0 ? Math.round((size / limit) * 100) : 0;

    const getStatus = (): 'normal' | 'exception' => {
        if (percentage >= STORAGE_LIMIT_THRESHOLD) return 'exception';
        return 'normal';
    };

    const popoverContent = (
        <div style={{ width: 400 }} className="storage-popover-content" data-testid="storage-popover-content">
            <StorageProgressBar />
        </div>
    );

    return (
        <Flex style={{ width: 88 }} justify={'space-between'} align={'center'} gap={5}>
            <DatabaseOutlined style={{ fontSize: 18 }} />
            <Popover placement="topRight" content={popoverContent} trigger="hover">
                <Flex vertical>
                    <span style={{ fontSize: 9, marginBottom: -7 }}>Storage ({percentage}%)</span>
                    <Progress
                        style={{ flex: 1, height: 10, width: 64 }}
                        percent={percentage}
                        status={getStatus()}
                        showInfo={false}
                    />
                </Flex>
            </Popover>
        </Flex>
    );
};
